/**
 * Minimum time a loader should stay visible so very fast API responses
 * don't cause a flicker. Tuned to feel smooth but still snappy.
 */
export const MIN_LOADER_MS = 700;

/**
 * Awaits the remaining time (if any) so that a loader stays visible for at
 * least `minMs` from the moment loading started.
 *
 * Usage:
 *   const startedAt = Date.now();
 *   try { ... } finally {
 *     await ensureMinLoader(startedAt);
 *     setLoading(false);
 *   }
 */
export const ensureMinLoader = async (startedAt, minMs = MIN_LOADER_MS) => {
  const elapsed = Date.now() - startedAt;
  if (elapsed < minMs) {
    await new Promise((resolve) => setTimeout(resolve, minMs - elapsed));
  }
};
